function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
import React from 'react';
// eslint-disable-next-line import/no-unresolved

import { BulletFillIcon } from '@applyboard/ui-icons';
import { NewChipStyled } from "./styles";
var ProductMarketingChip = function ProductMarketingChip(_ref) {
  var chipProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(NewChipStyled, _extends({
    icon: /*#__PURE__*/React.createElement(BulletFillIcon, null)
  }, chipProps), "New");
};
export { ProductMarketingChip };